module.exports = __webpack_public_path__ + "img/web-development.4af2fa4c.jpg";